import React from 'react';
import { Modal, Button } from 'react-bootstrap';
import './MessageModal.css';

const VARIANT_META = {
  success: { icon: '✓', title: 'Listo' },
  error:   { icon: '!', title: 'Ocurrió un problema' },
  warning: { icon: '!', title: 'Atención' },
  info:    { icon: 'i', title: 'Información' },
};

/**
 * Modal informativo transversal. Presenta un mensaje (éxito, error, aviso o
 * información) con un único botón "Aceptar" para cerrarlo. Reemplaza a los
 * <Alert> / mensajes inline que antes se mostraban en cada vista.
 *
 * Normalmente no se usa directo: se dispara con `useFeedback()` desde
 * `context/FeedbackContext`.
 */
const MessageModal = ({
  show,
  variant = 'info',
  title,
  message,
  onClose,
  onExited,
  acceptLabel = 'Aceptar',
}) => {
  const meta = VARIANT_META[variant] || VARIANT_META.info;
  const heading = title || meta.title;

  return (
    <Modal
      show={show}
      onHide={onClose}
      onExited={onExited}
      centered
      backdrop="static"
      dialogClassName={`msg-modal msg-modal--${variant}`}
    >
      <Modal.Header closeButton>
        <Modal.Title>
          <span className="msg-modal__icon" aria-hidden="true">{meta.icon}</span>
          {heading}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>{message}</Modal.Body>
      <Modal.Footer>
        <Button
          className="btn-artemis btn-artemis-sm btn-artemis-primary"
          onClick={onClose}
          autoFocus
        >
          {acceptLabel}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default MessageModal;
